import axios from 'axios';

// Menú de plataformas (platform_*). El baseURL de axios ya incluye /{tenant}/.
// Lectura: una sola llamada a /unified/raw trae menú, categorías, items, grupos
// de modificadores y sus enlaces. Escritura: endpoints granulares + recarga.
export default {
  menus() {
    return axios.get('/platform/menus');
  },
  unified(menuId) {
    return axios.get(`/platform/menu/${menuId}/unified/raw`);
  },

  // Categorías
  createCategory(menuId, data) {
    return axios.post(`/platform/menu/${menuId}/category`, data);
  },
  updateCategory(id, data) {
    return axios.put(`/platform/category/${id}`, data);
  },
  deleteCategory(id) {
    return axios.delete(`/platform/category/${id}`);
  },

  // Items (productos y modificadores comparten tabla; los distingue `type`)
  createItem(menuId, data) {
    return axios.post(`/platform/menu/${menuId}/item`, data);
  },
  updateItem(id, data) {
    return axios.put(`/platform/item/${id}`, data);
  },
  deleteItem(id) {
    return axios.delete(`/platform/item/${id}`);
  },
  addItemToCategory(categoryId, itemId) {
    return axios.post(`/platform/category/${categoryId}/item/${itemId}`, {});
  },
  removeItemFromCategory(categoryId, itemId) {
    return axios.delete(`/platform/category/${categoryId}/item/${itemId}`);
  },

  // Grupos de modificadores
  createModifierGroup(menuId, data) {
    return axios.post(`/platform/menu/${menuId}/modifiergroup`, data);
  },
  updateModifierGroup(id, data) {
    return axios.put(`/platform/modifiergroup/${id}`, data);
  },
  deleteModifierGroup(id) {
    return axios.delete(`/platform/modifiergroup/${id}`);
  },

  // Opciones dentro de un grupo (lleva precio, min/max y orden en el body)
  addOptionToGroup(groupId, itemId, data) {
    return axios.post(`/platform/modifiergroup/${groupId}/item/${itemId}`, data);
  },
  removeOptionFromGroup(groupId, itemId) {
    return axios.delete(`/platform/modifiergroup/${groupId}/item/${itemId}`);
  },

  // Qué grupos ofrece un producto
  attachGroupToItem(itemId, groupId) {
    return axios.post(`/platform/item/${itemId}/modifiergroup/${groupId}`, {});
  },
  detachGroupFromItem(itemId, groupId) {
    return axios.delete(`/platform/item/${itemId}/modifiergroup/${groupId}`);
  },

  // Copia de menús, misma semántica que la de Uber: sin selección = menú completo;
  // { category_ids } o { item_ids } = solo eso, con sus dependencias. Siempre
  // escribe sobre un menú destino existente.
  copyPlatformMenu(srcId, dstId, selection) {
    return axios.post(`/platform/menu/${srcId}/copyTo/${dstId}`, selection || {});
  },
  copyUberMenuToPlatform(uberMenuId, dstId, selection) {
    return axios.post(`/uber/mastermenu/${uberMenuId}/copyToPlatform/${dstId}`, selection || {});
  },
  uberMenus() {
    return axios.get('/uber/mastermenus');
  },
  uberCategories(uberMenuId) {
    return axios.get(`/uber/mastermenu/${uberMenuId}/categories`);
  },
  uberItems(uberMenuId) {
    return axios.get(`/uber/mastermenu/${uberMenuId}/items`);
  },

  // Catálogo del POS, para ligar item ↔ producto real (external_id)
  posProducts() {
    return axios.get('/products');
  },
  // El otro destino posible de external_id: una personalización se adjunta a
  // la línea del ticket en vez de generar una propia.
  posPersonalizations() {
    return axios.get('/personalizations');
  }
}
